// src/publish/pieces/facebookPost.js — pieces of the Facebook post (format key 'facebook-post').
//
// Same backend fields as the LinkedIn post plus cta_url. Pieces:
//   post      primary, kind 'plain', limit LIMITS.facebookPost (2000, 477
//             visible before «Altro…») — hook + body + cta + hashtag line
//   hashtags  kind 'tags', only when the backend sent any
//   link      kind 'url', the brief's cta_url (content.cta_url else
//             params.cta_url), only when there is one — Facebook has its own
//             link field, so the URL is not repeated inside the text
// A title, when present, is never part of the post.
// Labels / destinations: outputs:pieces.labels.facebook-post.* and
// outputs:pieces.destinations.facebook-post.* (see ../piece.js header).

import { makePiece, ctaUrlOf, tagsBlocks, urlBlocks, ensureOnePrimary, LIMITS } from '../piece.js';
import { socialPostBlocks } from './linkedinPost.js';

const FORMAT = 'facebook-post';

export function build(entry) {
  const content = entry?.results?.content;
  if (!content || typeof content !== 'object') return [];
  const pieces = [];

  const post = socialPostBlocks(content);
  if (post.length) pieces.push(makePiece(FORMAT, { id: 'post', primary: true, blocks: post, limit: LIMITS.facebookPost }));

  const tags = tagsBlocks(content.hashtags);
  if (tags.length) pieces.push(makePiece(FORMAT, { id: 'hashtags', kind: 'tags', blocks: tags }));

  const url = urlBlocks(ctaUrlOf(entry));
  if (url.length) pieces.push(makePiece(FORMAT, { id: 'link', kind: 'url', blocks: url }));

  return ensureOnePrimary(pieces);
}
